































































































import {
  createComponent,
  inject,
  onMounted,
  onUnmounted,
  computed,
  ref
} from "@vue/composition-api";

import DisplayUIKey from "@/components/display-ui-key";
import CompanyKey from "@/components/company-key";
import CompanyRecruitmentKey from "@/components/company-recruitment-key";
import FormHeader from '../../molecules/FormHeader.vue'
import DialogCardError from './DialogRegisterCardError.vue'
import CompanyErrorDialog from '../../../views/CompanyInformation/CompanyErrorDialog.vue'
import customValidator from "@/lib/customValidator.ts"

export default createComponent({
  setup() {
    const displayui = inject(DisplayUIKey);
    if (!displayui) {
      throw new Error(`${DisplayUIKey} is not provided`);
    }
    const company = inject(CompanyKey);
    if (!company) {
      throw new Error(`${CompanyKey} is not provided`);
    }
    const companyRecruitment = inject(CompanyRecruitmentKey);
    if (!companyRecruitment) {
      throw new Error(`${CompanyRecruitmentKey} is not provided`);
    }
    const creditCardForm = ref(null);
    const inputRegistDate = (e:string) => {
      company.inputRegistDate(e)
    }  
    const closeDialog = () => {
      company.clearRegistCardInfor()
      displayui.closeDialogRegisterCard()
    }
    const cardInfor = computed(() => company.registerCardInformation);
    const cardRegistration = async() => {
      //@ts-ignore
      if(!creditCardForm.value.validate()){
        return;
      }
      await company.registCreditCard()
      const tokenStatus = company.registerCardInformation.getTokenStatus
      const companyError = company.companyError
      if(tokenStatus === "invalid"){
        await displayui.openDialogCardError()
      } else if(companyError.status == '500'){
        await displayui.openDialogCardError()
      } else {
        await displayui.closeDialogRegisterCard()
      }
      
    }
    onUnmounted(() => {
      company.clearRegistCardInfor()
      displayui.closeDialogRegisterCard();
    })
    const closeWindow = computed(() => company.closeWindow);
    const dialogCard = computed(() => displayui.dialogRegisterCard);
    const formatMonth = (month: string) => displayui.formatMonth(month)
    return {
      cardInfor,
      cardRegistration,
      closeWindow,
      closeDialog,
      dialogCard,
      formatMonth,
      inputRegistDate,
      customValidator,
      creditCardForm
    };
  },
  components: {
    FormHeader,
    DialogCardError,
    CompanyErrorDialog
  },
})
